import React from "react";
import { Box, Typography, Card, IconButton, useTheme } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";

export default function LoadMoneyBankSection({ copyText }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  // ⭐ GET MOBILE NUMBER FROM REDUX (stored by setUser)
  const mobile = useSelector((state) => state.auth.user?.MobileNumber);
  const mmid = useSelector((state) => state.auth.user?.MMID);
  const accountnuber = useSelector((state) => state.auth.user?.AccountNo);
  const ifscCode = useSelector((state) => state.auth.user?.IFSCCode);
  const bankName = useSelector((state) => state.auth.user?.BankName);

  return (
    <Card
      sx={{
        background: isDark ? "#132237" : "#ffffff",
        borderRadius: "16px",
        p: 3,
        border: isDark
          ? "1px solid rgba(255,255,255,0.08)"
          : "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          mb: 3,
          color: isDark ? "#fff" : "#000",
          fontSize:{xs:15}
        }}
      >
        Load money from bank account through IMPS / NEFT using the below
        information.
      </Typography>

      <Box display="flex" justifyContent="space-between">
        {/* LEFT IMPS */}
        <Box width="48%">
          <Typography sx={{ fontWeight: 700, mb: 2 , fontSize:{xs:14}}}>
            OPTION 1: IMPS (Immediate transfer)
          </Typography>

          {/* ⭐ Show mobile number from API */}
          <FieldRow
            label="Mobile Number"
            value={mobile || "------"}
            copyText={copyText}
          />

          <FieldRow label="MMID" value={mmid} copyText={copyText} />

          <Typography sx={{ mt: 1, fontSize: {md:13, xs:8}, color: "red", }}>
            Note: For immediate transfer, please use Mobile number and MMID only
          </Typography>
        </Box>

        {/* RIGHT NEFT */}
        <Box width="48%">
          <Typography sx={{ fontWeight: 700, mb: 2, fontSize:{xs:14} }}>
            OPTION 2: NEFT (Minimum 2 hours)
          </Typography>

          <FieldRow
            label="Account Number"
            value={accountnuber || "------"}
            copyText={copyText}
          />

          <FieldRow label="IFSC" value={ifscCode} copyText={copyText} />

          <FieldRow
            label="Bank Name"
            value={bankName || "------"}
            copyText={copyText}
          />
        </Box>
      </Box>
    </Card>
  );
}

/* ---------------- FIELD ROW ---------------- */

function FieldRow({ label, value, copyText }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        mb: { xs: 1, sm: 2 },
        background: isDark ? "#0f1a29" : "#e9f9ee",
        borderRadius: "10px",

        // 🔥 reduce padding for mobile
        p: { xs: 1, sm: 1.5, md: 2 },
        px: { xs: 1.5, sm: 2.5, md: 4 },

        border: isDark ? "1px solid #1d334a" : "1px solid rgba(0,0,0,0.1)",
      }}
    >
      <Typography sx={{fontSize: { xs: 8, sm: 12, md: 13 }, opacity: 0.7 }}>{label}</Typography>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={{ fontSize: { xs: 8, sm: 16, md: 18 }, fontWeight: 700 }}>{value}</Typography>

        <IconButton onClick={() => copyText(value)}>
          <ContentCopyIcon
            sx={{ fontSize: { xs: 8, sm: 16, md: 18 }, color: isDark ? "#9bb3c9" : "#444" }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
